import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themeThree/level_one.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { style: {"color":"#fff"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "table-container" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "table-container" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "table-container" }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "table-container" }

import NoData from '@/themes/themeThree/components/common/noData.vue';
import { ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipTableView',
  props: {
    activeNo: {
        type: Number,
        required: true
    },
    tableData: {
        type: Array as () => any,
        required: false
    },
    activeData: {
        type: Object
    },
    vipRewardInfo: {
        type: Object
    },
    nextLevelRecord: {
        type: Object
    },
    nextLevel: {
        type: Number
    }
},
  setup(__props) {

const spanSize = computed(() => {
    let size = 0;
    const activeColCount = props.activeData?.isDailyReward + props.activeData?.isWeeklyRewards + props.activeData?.isMonthlyRewards;
    size = 18 / activeColCount
    return size;
});

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.activeNo == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_row, {
              class: "table-header",
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.betRequired')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.bonus')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "table-row",
                key: index,
                type: "flex",
                justify: "space-between",
                style: _normalizeStyle({ background:  Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "table-data",
                    style: {"color":"#f8e800"}
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "table-data",
                    style: {"color":"#6b6f79"}
                  }, {
                    default: _withCtx(() => [
                      (item.level == __props.nextLevel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createTextVNode(_toDisplayString(item.bet_min) + " ", 1),
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", {
                                class: "progress",
                                style: _normalizeStyle({ width: __props.vipRewardInfo?.betTotal / __props.nextLevelRecord?.bet_min < 1 ? __props.vipRewardInfo?.betTotal * 100 / __props.nextLevelRecord?.bet_min + '%' : '100%' })
                              }, null, 4),
                              _createElementVNode("div", {
                                class: "progress-end-dot",
                                style: _normalizeStyle({ left: `calc(${__props.vipRewardInfo?.betTotal * 100 / __props.nextLevelRecord?.bet_min}% - 6px)` })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.vipRewardInfo?.betTotal + '/' + __props.nextLevelRecord?.bet_min), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.bet_min), 1))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.upgrade_bonus ? item.upgrade_bonus : '--'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["style"]))
            }), 128)),
            (props.tableData.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (props.activeNo == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_row, {
              class: "table-header",
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.dailyBonus')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "table-row",
                key: index,
                type: "flex",
                justify: "space-between",
                style: _normalizeStyle({ background:  Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "table-data",
                    style: {"color":"#f8e800"}
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  (__props.activeData?.isDailyReward === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "12",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.daily_reward ?
                    item.daily_reward : '--'), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["style"]))
            }), 128)),
            (props.tableData.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (props.activeNo == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_row, {
              class: "table-header",
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.weeklyBonus')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "table-row",
                key: index,
                type: "flex",
                justify: "space-between",
                style: _normalizeStyle({ background:  Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "table-data",
                    style: {"color":"#f8e800"}
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  (__props.activeData?.isWeeklyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.week_reward ?
                    item.week_reward : '--'), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["style"]))
            }), 128)),
            (props.tableData.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (props.activeNo == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_van_row, {
              class: "table-header",
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "table-data table-head"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.monthlyBonus')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "table-row",
                key: index,
                type: "flex",
                justify: "space-between",
                style: _normalizeStyle({ background:  Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "table-data",
                    style: {"color":"#f8e800"}
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  (__props.activeData?.isMonthlyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.month_reward ?
                    item.month_reward : '--'), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["style"]))
            }), 128)),
            (props.tableData.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : (props.activeNo == 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_row, {
                class: "table-header",
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "table-data table-head"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                    ]),
                    _: 1
                  }),
                  (__props.activeData?.isDailyReward === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: spanSize.value,
                        class: "table-data table-head"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.dailyBonus')), 1)
                        ]),
                        _: 1
                      }, 8, ["span"]))
                    : _createCommentVNode("", true),
                  (__props.activeData?.isWeeklyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 1,
                        span: spanSize.value,
                        class: "table-data table-head"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.weeklyBonus')), 1)
                        ]),
                        _: 1
                      }, 8, ["span"]))
                    : _createCommentVNode("", true),
                  (__props.activeData?.isMonthlyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 2,
                        span: spanSize.value,
                        class: "table-data table-head"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.monthlyBonus')), 1)
                        ]),
                        _: 1
                      }, 8, ["span"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_row, {
                  class: "table-row",
                  key: index,
                  type: "flex",
                  justify: "space-between",
                  style: _normalizeStyle({ background: Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "5",
                      class: "table-data",
                      style: {"color":"#f8e400"}
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: ""
                        }, null, -1)
                      ])),
                      _: 1
                    }),
                    (__props.activeData?.isDailyReward === 1)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          span: spanSize.value,
                          class: "table-data",
                          style: {"color":"#6b6f79"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.daily_reward_retention), 1)
                          ]),
                          _: 2
                        }, 1032, ["span"]))
                      : _createCommentVNode("", true),
                    (__props.activeData?.isWeeklyRewards === 1)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 1,
                          span: spanSize.value,
                          class: "table-data"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.week_reward_retention), 1)
                          ]),
                          _: 2
                        }, 1032, ["span"]))
                      : _createCommentVNode("", true),
                    (__props.activeData?.isMonthlyRewards === 1)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 2,
                          span: spanSize.value,
                          class: "table-data"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.month_reward_retention), 1)
                          ]),
                          _: 2
                        }, 1032, ["span"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["style"]))
              }), 128)),
              (props.tableData.length <= 0)
                ? (_openBlock(), _createBlock(NoData, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}
}

})